import { PresetType } from './presets';
import { AutoRedactionJob } from './auto-redaction-job.model';

export class AutoRedactionRule {
  id: string;
  autoRedactionJobId: string;
  ruleTitle: string;
  rulePattern: string;
  redactionLabel: string;
  presetType: PresetType;
  redactionColorId: string;
  redactionCount: number;
  docCount: number;
  isDeleted: boolean;

  job?: AutoRedactionJob;
  rules?: [];
}
